import request from '@/utils/request'
import qs from 'qs'

export function login(data) {
  return request({
    url: '/api-oauth/login',
    method: 'post',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'clientId': 'web',
        'clientSecret': 'web'
    },
    data: qs.stringify(data)
  })
}

export function queryUsers(data) {
  return request({
    url: '/api-admin/user/queryUsers',
    method: 'get',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: qs.stringify(data)
  })
}

export function addUser(data) {
  return request({
    url: '/api-admin/user/addUser',
    method: 'post',
    headers: {
        'Content-Type': 'application/json',
    },
    data
  })
}

export function updateUser(data) {
  return request({
    url: '/api-admin/user/updateUser',
    method: 'post',
    headers: {
        'Content-Type': 'application/json',
    },
    data
  })
}

export function removeUser(data) {
  return request({
    url: '/api-admin/user/delete',
    method: 'post',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: qs.stringify(data)
  })
}

export function updateUserRole(data) {
  return request({
    url: '/api-admin/user/updateUserRole',
    method: 'post',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: qs.stringify(data)
  })
}
